import {
    DFM_APPROVED,
    DFM_PENDING_REVISION,
    DFM_WARNING_ACCEPTED,
    ImDfmStateType,
} from './constants'

export const getHasCustomerReviewedDfm = (status?: ImDfmStateType | null) =>
    status === DFM_APPROVED ||
    status === DFM_PENDING_REVISION ||
    status === DFM_WARNING_ACCEPTED
